import { useQuery } from "@tanstack/react-query";
import api from "../api";

const useGetIOCSummary = (iocValue: string) => {
  const { data, isLoading } = useQuery({
    queryKey: ["getIOCSummary", iocValue],
    queryFn: () => api.getIOCSummary(iocValue),
    select: ({ data: responseData }) => responseData,
    enabled: !!iocValue
  });

  return { data, isLoading };
};

export default useGetIOCSummary;
